// Colore stabile per utente: la stessa persona ha sempre lo stesso avatar.
export const userColor = (user) => `hsl(${(Number(user.id) * 67) % 360} 48% 42%)`;

// Colore stabile per cliente/richiedente, ricavato dall'email (uguale in anagrafica clienti e nei ticket).
export const customerColor = (c) => {
  let hash = 0;
  for (const ch of c.email || c.name || '') hash = (hash * 31 + ch.charCodeAt(0)) % 360;
  return `hsl(${hash} 48% 42%)`;
};

export const customerInitials = (c) => {
  const words = (c.name || '').trim().split(/\s+/).filter(Boolean);
  const letters = words.length > 1 ? words[0][0] + words[1][0] : (words[0] || c.email || '?').slice(0, 2);
  return letters.toUpperCase();
};
